import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { TableCellCustom } from '@app/components/table';
import { CustomAvatar } from '@app/components/custom-avatar';
import { IOverdueTasks } from '../type';

interface Props {
  row: IOverdueTasks;
  employee?: boolean;
}

const OverdueRow = (props: Props) => {
  const { row, employee } = props;
  return (
    <>
      {!employee && (
        <TableCellCustom flex align="center">
          <Stack
            gap={1}
            width={150}
            sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
          >
            <CustomAvatar
              name={`${row?.assignee?.firstName} ${row?.assignee?.lastName}`}
              src={row?.assignee?.profileImage}
              color={row?.assignee?.profileImage ? 'default' : 'info'}
              sx={{
                '& img': {
                  objectFit: 'cover',
                },
              }}
            />
            <Typography variant="body2" width={150}>
              {row?.assignee ? `${row.assignee.firstName} ${row.assignee.lastName}` : 'NA'}
            </Typography>
          </Stack>
        </TableCellCustom>
      )}
      <TableCellCustom flex align="center">
        <Typography variant="body2" minWidth={120}>
          {row?.boardName ?? 'NA'}
        </Typography>
      </TableCellCustom>
      <TableCellCustom>
        <Stack
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '9px',
            width: 140,
          }}
        >
          <CustomAvatar
            name={row.managedBy ? `${row.managedBy.firstName} ${row.managedBy.lastName}` : 'NA'}
            color="info"
          />
          <Typography variant="body2">
            {row.managedBy ? `${row.managedBy.firstName} ${row.managedBy.lastName}` : 'NA'}
          </Typography>
        </Stack>
      </TableCellCustom>
      <TableCellCustom align="center">
        <Typography variant="body2" width={300}>
          {row?.cardName ?? 'NA'}
        </Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2">
          {row?.cardStartDate ? dayjs(row?.cardStartDate).format('DD/MM/YYYY') : 'NA'}
        </Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2" width={100}>
          {dayjs(row?.cardEndTime).format('hh:mm a') ?? 'NA'}
        </Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2" width={100}>
          {row?.completedTime ? dayjs(row?.completedTime).format('hh:mm a') : 'NA'}
        </Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2" width={100}>
          {row?.expectedEta ?? 'N?A'}
        </Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2" width={100}>
          {row?.actualEta ?? 'N?A'}
        </Typography>
      </TableCellCustom>
    </>
  );
};

export { OverdueRow };
